import { observer } from "mobx-react";
import RequestProductStore from "../stores/request-product-store";
import { IValidationGroup } from "../../../hooks/validation-group/validation-group-hook";
import CreateRmaSettingsStore from "../stores/create-rma-settings-store";
import ListLayout from "../../../components/layouts/list-layout/list-layout";
import { FormField } from "../../../components/form-field/form-field";
import { FONT_COLOR, FONT_VARIANT } from "../../../components/fonts/font-props";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";
import { SelectDropdown } from "../../../components/inputs/select-dropdown/select-dropdown";
import FontBody2 from "../../../components/fonts/font-body2/font-body2";
import './policy-led-mode-item-drawer-fields.scss';
import Currency from "../../../components/currency/currency";




interface IProps {
	store:RequestProductStore;
	vGroup:IValidationGroup;
    createRmaSettingsStore: CreateRmaSettingsStore;
}

const PolicyLedModeItemDrawerFields: React.FC<IProps> = observer(({ store, vGroup, createRmaSettingsStore }) => {

    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';

    const policyRulesOptions = store.getPolicyRulesOptions();
    const selectedPolicyRule = policyRulesOptions.find(option => option.value === store.policyId);
    const returnMethodName = store.getReturnMethodName();
    const resolutionName = store.getResolutionName();
    
    return (
        <ListLayout>
			<FormField label={<FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('POLICY_RULE', pageScope)}</FontBody2>} required={true}>
				<SelectDropdown
					options={policyRulesOptions}
					value={selectedPolicyRule}
					onChange={(v) => store.setPolicyId(v?.value as number)}
					required
					validationGroup={vGroup}
                    isLoading={store.isCalculatingFees}
                    target={null}
                    placeholder={getTranslation('SELECT_PLACEHOLDER', pageScope)}
				/>
			</FormField>
            <div className="policy-led-row">
                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('RESOLUTION', pageScope)}</FontBody2>
                <FontBody2 color={FONT_COLOR.NEUTRAL3}>{resolutionName}</FontBody2>
            </div>
            <div className="policy-led-row">
                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('RETURN_METHOD', pageScope)}</FontBody2>
                <FontBody2 color={FONT_COLOR.NEUTRAL3}>{returnMethodName}</FontBody2>
            </div>
            {store.isRestockingFeeSupported && (
                <div className="policy-led-row">
                    <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('RESTOCKING_FEE_PER_ITEM', pageScope)}</FontBody2>
                    <FontBody2 color={FONT_COLOR.NEUTRAL3}><Currency currencyCode={store.paymentCurrencyCode} amount={store.restockingFee} /></FontBody2>
                </div>
            )}
            <div className="policy-led-row">
                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('ADJUSTMENTS_PER_ITEM', pageScope)}</FontBody2>
                <FontBody2 color={FONT_COLOR.NEUTRAL3}><Currency currencyCode={store.paymentCurrencyCode} amount={store.adjustments} /></FontBody2>
            </div>
		</ListLayout>
    )
});

export default PolicyLedModeItemDrawerFields;